import {generateUtilityClass, generateUtilityClasses} from './utils/classUtils';

export const LOGO_CLASS_NAME = 'AppLogo';
export const LOGO_CLASS_SLOTS = ['root', 'image', 'skeleton'] as const;

export type LogoClassSlot = typeof LOGO_CLASS_SLOTS[number];

export interface LogoClasses {
	root: string;
	image: string;
	skeleton: string;
}

export type LogoClassKey = keyof LogoClasses;

export const getLogoUtilityClass = (slot: string) =>
	generateUtilityClass(LOGO_CLASS_NAME, slot);

export const logoClasses = generateUtilityClasses<keyof LogoClasses>(
	LOGO_CLASS_NAME,
	['root', 'image', 'skeleton'],
);

export default logoClasses;
